import { Form, Text, NestedField, Checkbox, Field } from 'react-form';
import AsyncSelect from 'react-select/lib/Async';
import ReactModal from "react-modal";
import { isNullOrUndefined } from 'util';
import ViewSwitcher from "../General/ViewSwitcher";
import { AbconetApi } from '../General/AbconetApi';
import Select from 'react-select';
import React, { createRef } from 'react';
import { ProductPrice } from "../Product/ProductPrice";
import ReactTooltip from 'react-tooltip'
import { isOutOfStock } from "../General/Helper";
import { InStockContainer, InStockState } from '../Product/InStock';
import { OutOfStock } from '../Product/OutOfStock';
import { Template } from '..';
import withCart from '../General/withCart';
import { RSA_PKCS1_OAEP_PADDING } from 'constants';
import { QuantitySelector } from "../General/QuantitySelector";

export class TemplateViewLine extends React.Component {

    updateQuantity(ev) {
    
        this.props.updateQuantityChange(ev.target.value);
    }

    isOnAsl() {
        var product = this.props.templateLine.product;

        if (product.isApprovedStocklist) {
            return true;
        }

        if (this.props.address != null && this.props.address.approvedStocklistCollection != null) {
            var stockcodeList = this.props.address.approvedStocklistCollection.map((asl) => asl.lines.map((line) => line.stockcode))
            if (stockcodeList.length > 0) {
                return stockcodeList.reduce(function (a, b) { return a.concat(b); }).includes(product.stockcode);
            }
        }

        return false;
    }

    renderInStock() {

        if (isNullOrUndefined(this.props.address) || isNullOrUndefined(this.props.address.supplyLocation) || this.props.address.supplyLocation == '') {
            return null;
        }

        if (this.props.templateLine.product.stockAvailability) {
            var currentLocation = this.props.templateLine.product.stockAvailability.filter((location) => {
                return this.props.address.supplyLocation == location.locationName;
            });

            if (isNullOrUndefined(currentLocation[0]) || isNullOrUndefined(currentLocation[0].status)) {
                return;
            }

            return <InStockState stockAvailability={currentLocation[0]} hideInStock hideState />;
        }
    }

    renderApprovedStockListLogo() {
        if (this.isOnAsl()) {
            return <span className="asl-item p-3" ><i className="icon icon-approved" data-tip="Approved stocklist item"></i><ReactTooltip /></span>;
        }
        return null;
    }

    renderInputFields(product, isCompact) {
        var checkboxId = "rechargeable" + product.stockcode;

        if (this.props.limitOrderToApprovedStocklist && product.isApprovedStocklist == false) {
            return <small className="col-2">
                This product is not on your approved stocklist and can't be ordered.
            </small>

        }

        var supplyLocation = "";
        var cart = null;
        if (this.props.address) {
            supplyLocation = this.props.address.supplyLocation;
        }
        cart = { supplyLocation: supplyLocation }

        return <React.Fragment>
            <div className="col-2 col-md-2 col-lg-1 input-qty-container">
                <QuantitySelector
                    key={this.props.templateLine.product.stockcode}
                    cart={cart}
                    item={this.props.templateLine.product}
                    onChange={this.updateQuantity.bind(this)}
                    value={this.props.value}
                    unit={this.props.templateLine.product.unit ? this.props.templateLine.product.unit : "Unit"}
                    unitPlural={this.props.templateLine.product.unitPlural ? this.props.templateLine.product.unitPlural : "Units"}
                    packQty={this.props.templateLine.product.packQty}
                    palletQty={this.props.templateLine.product.palletQty}
                    layerQty={this.props.templateLine.product.layerQty} />
            </div>
            <div className={`col-12 ${!isCompact ? 'col-lg-2' : 'col-lg-1'} actions-container rechargeable-column`}>
                <div className="custom-control custom-checkbox my-1 mr-sm-2 d-inline">
                    <Checkbox field="rechargeable" id={checkboxId} className="custom-control-input" disabled={!this.props.canEdit} />
                    <label className="custom-control-label" htmlFor={checkboxId}><span className="d-lg-none">Rechargable</span></label>
                </div>
            </div>
        </React.Fragment>
    }


    renderShowAlternativesButton(isCompact) {
        if (this.props.templateLine.product.alternativeProductCollection.length == 0) {
            return null;
        }
        if (this.props.showAlternatives) {
            if (isCompact) {
                return <a className='alternative-close close template-compact' onClick={() => { this.props.removeAltProducts(); this.props.showAlternativesHandler(this.props.templateLine.product.stockcode); }}><i className="icon icon-dropdown-arrow" /></a>
            }
            return <a className='alternative-close close' onClick={() => { this.props.removeAltProducts(); this.props.showAlternativesHandler(this.props.templateLine.product.stockcode); }}><i className="icon icon-dropdown-arrow"/></a>
        }
        return <a className="alternative-btn btn-show-alternatives btn btn-link btn-sm alternate-btn" onClick={() => {
            this.props.showAlternativesHandler();
            //this.setState({ showAlternatives: true });
            this.props.openAlternativesCallback();
        }}>Show Alternatives</a>;
    }


    render() {

        var product = this.props.templateLine.product;
        var size = product.imageFileName == 'no-image.svg' ? '40' : '';
        if (this.props.isCompactView) {
            return (
                <div key={product.stockcode} className='compact'>
                    <div className="row">
                        <div className="col-7 col-md-8 col-lg-9 z-index-4">
                            <p className="description">{product.name}</p>
                            <div className='template-compact template-info'>
                                <span className="stockcode p-2" style={{ marginRight: '13px' }}>{product.stockcode}</span>
                                {this.renderApprovedStockListLogo()}
                                {this.renderShowAlternativesButton(this.props.isCompactView)}
                                {this.renderInStock()}
                            </div>
                        </div>
                        <div className="col-3 col-md-2 col-lg-1">
                            <ProductPrice product={product} />
                        </div>
                        {this.renderInputFields(product, this.props.isCompactView)}
                    </div>
                </div>
            );
        } else {
            return (
                    <div className='item' key={product.stockcode}>

                        <div className='row'>
                            <div className="col-2 col-lg-1">
                            <a href={product.url}><img src={product.imageFileName} className="product-image" width={size} /></a>
                            </div>
                            <div className="col-5 col-lg-6 z-index-4">
                                <p className="description">{product.name}</p>
                                <div className='template-info'>
                                <span className="stockcode" style={{ marginRight: '13px' }}>Code: {product.stockcode}</span>
                                    {this.renderInStock()}
                                    {this.renderApprovedStockListLogo()}
                                    {this.renderShowAlternativesButton()}
                                </div>
                                
                            </div>
                        <div className="col-3 col-lg-2" style={{textAlign: 'center'}}>
                                <ProductPrice product={product} />
                            </div>

                            {this.renderInputFields(product)}
                        </div>
                    </div>

            );
        }

    }
}


export class TemplateView extends React.Component {

    constructor(props) {
        super(props);
        this.cronText = React.createRef();
        this.state = {
            isSaved: true,
            scheduleModalOpen: false,
            permissionsModalOpen: false,
            isSaving: false,
            isGroupSaved: true,
            isGroupSaving: false,
            isCompactView: false,
            sortBy: 'stockcodeAsc',
            template: this.props.initialTemplate,
            showAlternatives: {},
        }
    }

    componentDidMount() {
        window.addEventListener("beforeunload", this.onUnload.bind(this));
    }



    onUnload(event) {

        if (this.state.isSaved == false && this.state.isSaving == false) {
            event.returnValue = "Stop";
        }
    }

    setViewSwitcher(data) {
        this.setState({ isCompactView: data.isCompactView });
    }

    setChange() {
        this.setState({ isSaved: false });
    }

    setEditMode() {
        if (this.props.onSetEditMode) {
            this.props.onSetEditMode();
        }
    }

    submitTemplate(submittedValues) {
        this.setState({ submittedValues, isSaving: true }, this.createCart);
    }


    createCart() {
        var seqno = this.props.initialTemplate.id;

        if (seqno === 0) {
            alert('Please populate the template first.');
            return;
        }

        var cartLines = [];
        var lineCollection = this.state.submittedValues.lines;

        var self = this;

        lineCollection.forEach(function (line) {


            if (self.props.limitOrderToApprovedStocklist && line.product.isApprovedStocklist == false) {
                return;
            } 

            var cartLine = {
                quantity: line.quantity,
                stockcode: line.product.stockcode,
                rechargeable: line.rechargeable,
                rechargePercentage: line.rechargePercentage
            };

            cartLines.push(cartLine);
            
        });

        var cart = {
            address: this.state.submittedValues.linkedSite,
            lines: cartLines,
            templateId: seqno

        }

        AbconetApi.post('/api/cart/', cart).then(response => {

            if (response.exceptionMessage) {
                alert(response.exceptionMessage);
            } else {
                window.location = `/cart/${response.id}/`;
            }
        }).catch(() => {
            this.setState({
                isSaving: false
            });
        });
    }

    updateQuantity(line, ev) {
        var lineCollection = this.formApi.getValue("lines");

        var index = lineCollection.findIndex(function (obj) {
            return obj.product['stockcode'] === line.product.stockcode;
        });

        if (ev <= -1) {
            lineCollection[index].quantity = 0;
        } else {
            lineCollection[index].quantity = ev;
        }

        this.formApi.setValue("lines", lineCollection);

        this.state = {
            isSaved: false,
            sortBy: this.state.sortBy
        }
    }

    handleSortChange(selectedOption) {
        this.setState({ sortBy: selectedOption.value });
    }

    renderTableHeader(lines, isCompactView) {
        if (lines == null || lines.length === 0) {
            return;
        }

        const { sortBy } = this.state.sortBy;
        var options = [
            { value: 'productcodeAsc', label: 'Stockcode code - Ascending' },
            { value: 'productcodeDesc', label: 'Stockcode code - Descending' },
            { value: 'priceAsc', label: 'Price - Ascending' },
            { value: 'priceDesc', label: 'Price - Descending' },
            { value: 'nameAsc', label: 'Name - Ascending' },
            { value: 'nameDesc', label: 'Name - Descending' }
        ];
        var sort = <div>
            <Select
                className="sort-by-dropdown"
                value={sortBy}
                onChange={this.handleSortChange.bind(this)}
                options={options}
                placeholder="Sort by..."
            />
        </div>;

        var switcher =
            <div className="col-12">
                <div className="row">
                    <div className="col-6">
                        {sort}
                    </div>
                    <div className="col-6">
                        <ViewSwitcher onChange={this.setViewSwitcher.bind(this)} />
                    </div>
                </div>
            </div>;

        if (isCompactView) {
            return <div className="row header">
                {switcher}
                <div className="col-7 col-sm-9 col-lg-9 col-hd text-center">
                    Item
                       </div>
                <div className="col-3 col-sm-2 col-lg-1 text-center col-hd">
                    Price
                       </div>
                <div className="col-1 col-sm-2 col-lg-1 text-center col-hd">
                    Qty
                       </div>
                <div className="col-lg-1 col-hd d-none text-center d-lg-block">
                    Rchg
                       </div>
            </div>;
        }

        return <div className="row header">
            {switcher}
            <div className="col-8 col-sm-8 col-md-8 col-lg-7 col-hd" style={{textAlign: 'center'}}>
                Item
               </div>
            <div className="col-2 col-sm-3 col-md-3 col-lg-2 text-center col-hd">
                Price
               </div>
            <div className="col-2 col-sm-2 col-md-2 col-lg-1 col-hd text-center input-qty-container">
                Qty
               </div>
            <div className="col-lg-2 text-center col-hd d-none d-lg-block">
                Rechargable
               </div>
        </div>;
    }

    renderCreateOrderButton() {
        var self = this;
        if (this.props.initialTemplate.id !== 0) {
            var buttonClass = "btn btn-secondary float-right";

            var buttonText = "Create Order";

            if (this.state.isSaving) {
                buttonClass += " saving";
                buttonText = "Creating Order";
            }

            return <button className={buttonClass} disabled={this.state.isSaving}>{buttonText}</button>;
        }
    }

    renderUpperButtons() {
        if (this.formApi.getValue("lines") != null && this.formApi.getValue("lines").length >= 5) {
            return this.renderCreateOrderButton();

        }
    }

    renderLinkedSite() {
        if (this.props.initialTemplate.id !== 0 && !isNullOrUndefined(this.formApi.values.linkedSite)) {
            return <h5>Linked Site: {this.formApi.values.linkedSite.name}</h5>;
        }

        return <h5>Linked Site: </h5>;
    }

    renderEditButton() {
        if (this.props.initialTemplate.canEdit) {
            return <button className="btn btn-primary float-right btn-edit-template" onClick={this.setEditMode.bind(this)}>Edit</button>;
        }
    }

    getSortedLines(formLines) {
        if (!formLines) {
            return [];
        }

        var returnArray = [];

        for (var i = 0; i < formLines.length; i++) {
            var line = formLines[i]

            if (!line.isAlternative) {
                returnArray.push({
                    index: i,
                    line: line
                })
            }
        }

        var sortBy = this.state.sortBy;
        switch (sortBy) {
            case 'productcodeAsc':
                returnArray.sort((a, b) => {
                    if (a.line.product.stockcode < b.line.product.stockcode) { return -1; }
                    if (a.line.product.stockcode > b.line.product.stockcode) { return 1; }
                    return 0;
                });
                break;
            case 'productcodeDesc':
                filteredFormLines.sort((a, b) => {
                    if (a.line.product.stockcode > b.line.product.stockcode) { return -1; }
                    if (a.line.product.stockcode < b.line.product.stockcode) { return 1; }
                    return 0;
                });
                break;
            case 'priceAsc':
                filteredFormLines.sort((a, b) => {
                    return b.line.product.bestPrice - a.line.product.bestPrice;
                });
                break;
            case 'priceDesc':
                filteredFormLines.sort((a, b) => {
                    return a.line.product.bestPrice - b.line.product.bestPrice;
                });
                break;
            case 'nameAsc':
                filteredFormLines.sort((a, b) => {
                    if (a.line.product.name < b.line.product.name) { return -1; }
                    if (a.line.product.name > b.line.product.name) { return 1; }
                    return 0;
                });
                break;
            case 'nameDesc':
                filteredFormLines.sort((a, b) => {
                    if (a.line.product.name > b.line.product.name) { return -1; }
                    if (a.line.product.name < b.line.product.name) { return 1; }
                    return 0;
                });
                break;

        }
        //remove all altProducts from formLines
        return returnArray;
    }

    getAltProductLines(formLines, originalLine) {
        if (!formLines) {
            return [];
        }

        
        var isAltOfOriginalLine = false;
        var returnArray = [];
        for (var i = 0; i < formLines.length; i++) {
            var line = formLines[i]           

            if (isAltOfOriginalLine && line.isAlternative && line.originalStockCode == originalLine.line.product.stockcode) {
                returnArray.push({
                    index: i,
                    line: line
                })                
            }

            if (line.product.stockcode == originalLine.line.product.stockcode && !line.isAlternative) {
                isAltOfOriginalLine = true;
            } else if (isAltOfOriginalLine && line.isAlternative) {
                isAltOfOriginalLine = true;
            } else {
                isAltOfOriginalLine = false;
            }
        }

        return returnArray;
    }

    addAltProducts(line, formApi) {

        var existingAlternatives = this.state.showAlternatives;
        
        existingAlternatives[line.product.stockcode] = true;
        this.setState({ showAlternatives: existingAlternatives});

        var existingLineCollection = formApi.values.lines;

        for (var i = 0; i < existingLineCollection.length; i++) {

            var existingLine = existingLineCollection[i];

            if (line.seqno === existingLine.seqno) {

                for (var x = 0; x < line.product.alternativeProductCollection.length; x++) {

                    var altProduct = line.product.alternativeProductCollection[x];

                    existingLineCollection.splice([i + 1], 0,
                        {
                            seqno: line.seqno + '-' + altProduct.stockcode,
                            product: altProduct,
                            quantity: 0,
                            rechargeable: line.rechargeable,
                            isAlternative: true,
                            originalStockCode: line.product.stockcode
                        }
                    );
                }
            }
        }

        formApi.setValue('lines', existingLineCollection);
    }
    removeAltProductLines(altProducts, formApi) {
        var existingLineCollection = formApi.values.lines.filter((line) => {

            for (var x = 0; x < altProducts.length; x++) {
                if (altProducts[x].line.seqno == line.seqno) {
                    return false;
                }
            }
            return true;
        });

       
        formApi.setValue('lines', existingLineCollection);
    }

    showAlternativesHandler(altProduct) {
        if (this.state.showAlternatives[altProduct.product.stockcode]) {
            let stockcode = altProduct.product.stockcode;
            this.setState((prevState) => ({
                showAlternatives: {
                    ...prevState.showAlternatives,
                    [stockcode]: false
                }
            }))
        }
    }

    render() {
        var self = this;
        self.isCompactView = self.state.isCompactView;

        var template = this.state.template;

        var viewAllTemplates = <a href="/templates" className="btn btn-outline-primary">View all templates</a>;
        if (this.props.limitToSite) {
            viewAllTemplates = null;
        }

        //console.log('initial template', this.props.initialTemplate);
        return (
            <div className="template template-view pb-5">
                
                <Form
                    onChange={this.setChange.bind(this)}
                    onSubmit={this.submitTemplate.bind(this)} defaultValues={this.props.initialTemplate}>
                    {formApi => {
                        self.formApi = formApi;
                        var isCompactView = self.isCompactView;
                        var extraHeaderClass = "";
                        if (isCompactView) {
                            extraHeaderClass += " list-compact";
                        }

                        var templateHeader = <div className="card card-body bg-light">
                            {this.renderEditButton()}
                            <h4>{formApi.values.name}</h4>
                            {this.renderLinkedSite()}
                        </div>;

                        if (this.props.limitToSite) {
                            templateHeader = null;
                        }

                        return (
                            <div className='item'>
                                <form onSubmit={formApi.submitForm} id="dynamic-form">
                                    {templateHeader}
                                    <div className={"list-group" + extraHeaderClass}>
                                        {self.renderTableHeader(formApi.values.lines, isCompactView)}
                                        {formApi.values.lines &&
                                            this.getSortedLines(formApi.values.lines).map((line) => {

                                                let altProductLineCollection = this.getAltProductLines(formApi.values.lines, line);

                                                //console.log('lines', line)

                                                //console.log('Alt products', altProductLineCollection)

                                                //formApi.values.lines.map((line, i) => ( old code
                                                
                                                return (
                                                    <div>
                                                        <NestedField field={['lines', line.index]} key={"template-lines-" + line.index}>
                                                            <TemplateViewLine
                                                                templateLine={line.line}
                                                                value={line.line.quantity}
                                                                updateQuantityChange={this.updateQuantity.bind(self, line.line)}
                                                                limitOrderToApprovedStocklist={self.props.limitOrderToApprovedStocklist}
                                                                address={template.linkedSite}
                                                                isCompactView={isCompactView}
                                                                canEdit={this.props.initialTemplate.canEdit}
                                                                openAlternativesCallback={this.addAltProducts.bind(this, line.line, formApi)}
                                                                removeAltProducts={this.removeAltProductLines.bind(this, altProductLineCollection, formApi)}
                                                                showAlternatives={altProductLineCollection.length > 0}
                                                                showAlternativesHandler={this.showAlternativesHandler.bind(this, line.line)}
                                                            />

                                                        </NestedField>
                                                        {altProductLineCollection && (<div className='alt-stock open alt'>

                                                            {altProductLineCollection.map((altProduct) => (
                                                                <div>

                                                                    <NestedField field={['lines', altProduct.index]} key={"template-lines-" + altProduct.index}>
                                                                        <TemplateViewLine
                                                                            templateLine={altProduct.line}
                                                                            updateQuantityChange={this.updateQuantity.bind(self, altProduct.line)}
                                                                            limitOrderToApprovedStocklist={self.props.limitOrderToApprovedStocklist}
                                                                            address={template.linkedSite}
                                                                            isCompactView={isCompactView}
                                                                            canEdit={this.props.initialTemplate.canEdit}
                                                                        />
                                                                    </NestedField>
                                                                </div>
                                                            ))}

                                                        </div>)}
                                                    </div>)
                                            })}
                                    </div>
                                    {this.renderCreateOrderButton()}
                                </form>

                            </div>
                        );
                    }}
                </Form>
                {viewAllTemplates}

            </div>
        );
    }
}

export const ProductRow = withCart(TemplateViewLine);